var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.71,
    height: 40,
    viewBox: "0 0 108.71 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGO",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1502",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M18.709,4.1H-90V-25H12.893a5.894,5.894,0,0,1,3.991,1.622,5.8,5.8,0,0,1,1.825,4.262V4.1ZM-49.874-4.262v.343c.253.024.509.036.761.036a9.145,9.145,0,0,0,4.3-1.141,20.43,20.43,0,0,0,5.005-3.928c1.508,1.324,1.76,1.529,2.31,1.978.263.214.472.392.656.549.9.767.973.829,2.45.829h2.651c-.007-.005-1.125-.977-2.541-2.207l-3.7-3.213a21.291,21.291,0,0,1,3.215-3.049,6.552,6.552,0,0,1,3.839-1.467v-.41c-3.457,0-5.811,1.543-8.281,3.858l-1.439-1.252-.009-.007-.731-.636c-.141-.123-.268-.237-.38-.338a2.843,2.843,0,0,0-2.521-.976h-2.761c1.473,1.289,2.69,2.355,3.7,3.24l2.229,1.952c-.257.257-.519.524-.8.808-2.2,2.245-4.932,5.037-7.739,5.038C-49.728-4.257-49.8-4.258-49.874-4.262ZM-75.785-9.3h4.124c1.493,0,2.338.172,2.338,3.7l3.362,0a4.06,4.06,0,0,0-2.33-4.1,2.769,2.769,0,0,0,2.18-2.868c0-1.834-1.271-2.725-3.887-2.725h-9.13V-5.6h3.343V-9.3Zm61.867-5.995v6.982a2.328,2.328,0,0,0,.935,2.047,4.893,4.893,0,0,0,2.857.668h7.089V-6.8H-9.675a.816.816,0,0,1-.932-.924v-7.574Zm-9.681-.234a9.251,9.251,0,0,0-4.47.92,4.261,4.261,0,0,0-2.2,4.019c0,4.5,3.48,4.99,4.976,4.99h7.89V-6.784H-24.42c-2.168,0-2.369-.872-2.391-3.364h10.254c.012-.137.013-.286.013-.44A4.247,4.247,0,0,0-18.5-14.608a9.478,9.478,0,0,0-4.8-.92Zm-32.928,0a9.237,9.237,0,0,0-4.464.92,4.261,4.261,0,0,0-2.2,4.019c0,4.5,3.482,4.99,4.979,4.99h7.882V-6.784h-7.013c-2.164,0-2.367-.872-2.394-3.364h10.261c0-.066,0-.134,0-.2s0-.157,0-.236a4.248,4.248,0,0,0-1.953-4.019,9.48,9.48,0,0,0-4.8-.92Zm-14.484,5.1h-4.774v-3.81h5.034a1.044,1.044,0,0,1,.913.53,2.289,2.289,0,0,1,.3,1.2C-69.54-11.5-70.056-10.425-71.012-10.425ZM-20-11.253h-6.809a4.1,4.1,0,0,1,.616-2.549,2.124,2.124,0,0,1,1.775-.575h2.026a2.121,2.121,0,0,1,1.775.575A4.123,4.123,0,0,1-20-11.254Zm-32.925,0H-59.74c.073-2.673.8-3.124,2.394-3.124h2.026a2.126,2.126,0,0,1,1.777.575,4.114,4.114,0,0,1,.617,2.548Z",
    transform: "translate(90 25)",
    fill: "#0a287d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g909",
    transform: "translate(0.001 30.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path911",
    d: "M0,2.846A5.829,5.829,0,0,0,5.833,8.733H108.709v-9.7H0Z",
    transform: "translate(0 0.967)",
    fill: "#4487bd"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.d900eafe92bb6cd860abea49d25f8b99.svg";